import { ReactNode } from 'react';

import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface SearchListWrapperProps {
  sectionName: string;
  children: ReactNode;
}

export default function SearchListWrapper({
  sectionName,
  children,
}: SearchListWrapperProps) {
  return (
    <Stack>
      <Typography fontWeight="bold">{`${sectionName}`}</Typography>
      <List
        sx={{
          pl: 0.5,
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          flexWrap: 'wrap',
          alignItems: 'stretch',
          width: '100%',
          maxHeight: '150px',
          overflowY: 'auto',
        }}
      >
        {children}
      </List>
    </Stack>
  );
}
